import { render, staticRenderFns } from "./TiPainelItau.vue?vue&type=template&id=0a3557f4&scoped=true"
import script from "./TiPainelItau.vue?vue&type=script&lang=js"
export * from "./TiPainelItau.vue?vue&type=script&lang=js"
import style0 from "./TiPainelItau.vue?vue&type=style&index=0&id=0a3557f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3557f4",
  null
  
)

export default component.exports